// eslint-disable-next-line
import { itemQueryFilter, itemQueryFilterByCategory } from 'utils/proptypes';
import base from './baseApi';
import { omitBy } from 'lodash';
import { createSearchParams } from 'react-router-dom';

const { urls, methods, execute } = base();
const DEFAULT_ITEM_BATCH_LIMIT = 100;

const streamItemPages = async (loadPage: any, onPage?: any, limit = DEFAULT_ITEM_BATCH_LIMIT) => {
  const firstRes: any = await loadPage(0, limit);
  const totalCount = firstRes?.data?.totalEntities || 0;
  const pageBreak = Math.ceil(totalCount / limit);
  const firstPageEntities = firstRes?.data?.entities || [];
  let entities = [...firstPageEntities];

  if (onPage && firstPageEntities.length > 0) {
    await onPage(firstPageEntities, { page: 0, totalPages: pageBreak, totalEntities: totalCount });
  }

  for (let index = 1; index < pageBreak; index++) {
    const resPage: any = await loadPage(index, limit);
    const pageEntities = resPage?.data?.entities || [];
    entities = entities.concat(pageEntities);

    if (onPage && pageEntities.length > 0) {
      await onPage(pageEntities, { page: index, totalPages: pageBreak, totalEntities: totalCount });
    }
  }

  return {
    entities,
    totalEntities: totalCount,
  };
};

const getItemsByFilter = (queryFilter: itemQueryFilter) => {
  const method = methods.GET;
  const initParams: any = omitBy(queryFilter, v => v === '');
  const params = createSearchParams(initParams);

  const url = `${urls.item.item}/?${params.toString()}`;
  const response = execute(method, url, { authorization: true });

  return response;
};

const getAllItemsByFilter = async (queryFilter: itemQueryFilter, limit = DEFAULT_ITEM_BATCH_LIMIT) => {
  return streamItemPages((page: number, pageLimit: number) => getItemsByFilter({ ...queryFilter, page, limit: pageLimit }), undefined, limit);
};

const streamAllItemsByFilter = async (queryFilter: itemQueryFilter, onPage: any, limit = DEFAULT_ITEM_BATCH_LIMIT) => {
  return streamItemPages((page: number, pageLimit: number) => getItemsByFilter({ ...queryFilter, page, limit: pageLimit }), onPage, limit);
};

const getItemsByCategory = (queryFilter: itemQueryFilterByCategory) => {
  const method = methods.GET;
  const initParams: any = omitBy(queryFilter, v => v === '');
  const params = createSearchParams(initParams);

  const url = `${urls.item.item}/by-category?${params.toString()}`;
  const response = execute(method, url, { authorization: true });

  return response;
};

const getAllItemsByCategory = async (queryFilter: itemQueryFilterByCategory, limit = DEFAULT_ITEM_BATCH_LIMIT) => {
  return streamItemPages((page: number, pageLimit: number) => getItemsByCategory({ ...queryFilter, page, limit: pageLimit }), undefined, limit);
};

const streamAllItemsByCategory = async (queryFilter: itemQueryFilterByCategory, onPage: any, limit = DEFAULT_ITEM_BATCH_LIMIT) => {
  return streamItemPages((page: number, pageLimit: number) => getItemsByCategory({ ...queryFilter, page, limit: pageLimit }), onPage, limit);
};

const getItems = () => {
  const method = methods.GET;
  const url = `${urls.item.item}?limit=10`;
  const response = execute(method, url, { authorization: true });

  return response;
};

const getItemById = (id: string) => {
  const method = methods.GET;
  const url = `${urls.item.item}/${id}`;
  const response = execute(method, url, { authorization: true });

  return response;
};

const getItemByUpc = (upc: string, organizationId: string) => {
  const method = methods.GET;
  const url = `${urls.item.item}/upc/${upc}/${organizationId}`;
  const response = execute(method, url, { authorization: true });

  return response;
};

const createItem = (payload: any) => {
  const method = methods.POST;
  const url = `${urls.item.item}`;
  const response = execute(method, url, { authorization: true }, payload);

  return response;
};

const updateItemById = (id: any,payload: any) => {
  const method = methods.PUT;
  const url = `${urls.item.item}/${id}`;
  const response = execute(method, url, { authorization: true }, payload);
  return response;
};

const mergeItem = (sourceId: any,desId: any) => {
  const method = methods.PUT;
  const url = `${urls.item.item}/merge/${sourceId}/${desId}`;
  const response = execute(method, url, { authorization: true });
  return response;
};

const deleteItemById = (id: string) => {
    const method = methods.DELETE;
    const url = `${urls.item.item}/${id}`;
    const response = execute(method, url, { authorization: true });
  
    return response;
  };

export {
    getItemsByFilter,
    getAllItemsByFilter,
    streamAllItemsByFilter,
    getItemsByCategory,
    getAllItemsByCategory,
    streamAllItemsByCategory,
    getItems,
    getItemById,
    getItemByUpc,
    createItem,
    updateItemById,
    mergeItem,
    deleteItemById
};
